let Api = {
    "CATEGORYMAGE_MAGETREE":"/system/w/categoryMage/findCommMageTree",//品类列表
    "COMMVARIETMAGE_FINDLIST":"/system/w/commVarietMage/findCommVarierMageListNoPage",//查询商品品种列表
	"PLACEMAGE_FINDPAGELIST": "/system/w/placeMage/findPageList", //分页查询产地列表
    "PLACEMAGE_EXPORTPLACE": "/system/w/placeMage/exportPlace", //导出产地列表
    "PLACEMAGE_FINDINFO": "/system/w/placeMage/findInfo", //查询产地详情
    "PLACEMAGE_SAVEORUPDATE":"/system/w/placeMage/saveOrUpdate",//新增或修改产地信息
    "PLACEMAGE_MEMBPAGELIST":"/system/w/placeMage/findPlaceMembPageList",//分页查询产地用户列表
    "PLATMEMB_RESETPWD":"/system/w/platMemb/resetPwd",//重置密码

    // 产业服务 - 商品列表
    "PROVIDER_W_PRODUCT_PLATFINDPAGELIST": "/indust/w/product/platFindPageList", //分页查询商品列表
    "PROVIDER_W_PRODUCT_EXPORTPRODUCT": "/indust/w/product/exportProduct", //分页查询商品列表导出
    "PROVIDER_W_PRODUCT_BATCHSTATUS":"/indust/w/product/batchStatus", // 商品批量上架下架

    // 产业服务 - 商品预览
    "PROVIDER_W_PRODUCT_FINDINFO": "/indust/w/product/findInfo", //查询商品详情

    // 产业服务 - 商品分类
    "PROVIDER_CATEGORYMAGE_PAGETREE": "/indust/w/categoryMage/findCommMageTree", //分类列表 /system/w/categoryMage/findPageCommMageTree
    //"PROVIDER_CATEGORYMAGE_EXPORT": "/system/w/categoryMage/exportCategoryMage",// 分类导出
    "PROVIDER_CATEGORYMAGE_SAVEORUPDATE": "/indust/w/categoryMage/saveOrUpdate", //分类新增or修改
    "PROVIDER_CATEGORYMAGE_DEL": "/indust/w/categoryMage/del", //分类删除
    "PROVIDER_CATEGORYMAGE_INFO":"/indust/w/categoryMage/findCommMageInfo", //查询基础分类详细信息

    // 产业服务 - 服务单列表
    "PROVIDER_ORDER_FINDPAGELIST":"/indust/w/order/findPlatPageList",//分页查询订单列表
    // "PROVIDER_ORDER_EXPORT":"/trade/w/order/exportOrder",//导出订单列表
    "PROVIDER_ORDER_FINDSHOPORDERINFO": "/indust/w/order/findOrderInfo", //查询订单详细信息

}
module.exports = Api